import {endpoints} from './endpoints'
import request from '../helpers/request'

export function cameraList(){
	return new Promise((resolve, reject) => {
    request({
      url: endpoints.cameraList,
      method: 'post'
    })
		  .then(function (response) {
		    resolve(response)
		  })
		  .catch(function (error) {
		    resolve(error)
		  });
	})
}
export function getTuyaCameraVideoInfo(data){
	return new Promise((resolve, reject) => {
    request({
      url: endpoints.getTuyaCameraVideoInfo,
      method: 'post',
			data
    })
		  .then(function (response) {
		    resolve(response)
		  })
		  .catch(function (error) {
		    resolve(error)
		  });
	})
}
export function cameraPtzMove(data){
	return new Promise((resolve, reject) => {
    request({
      url: endpoints.cameraPtzMove,
      method: 'post',
			data
    })
		  .then(function (response) {
		    resolve(response)
		  })
		  .catch(function (error) {
		    resolve(error)
		  });
	})
}